import type { ExpenseSettleMethod } from '../../expenses/components/expenseSettlementMethods';
import { PurchaseValidationError } from '../domain/purchaseErrors';
import {
  isoDateToPaidAt,
  resolveSettleMethodFromPaymentForm,
  type ExpenseAlreadyPaidKind,
  type ExpensePaidFormChoice,
} from '../../expenses/components/expensePaymentFlow';

export type PurchasePaymentOnReceive = {
  method: ExpenseSettleMethod;
  cashSessionId?: string | null;
  note?: string | null;
  paidAt?: string;
};

export function resolvePurchaseReceptionSettleMethod(input: {
  paidForm: ExpensePaidFormChoice | null;
  alreadyPaidKind: ExpenseAlreadyPaidKind | null;
  nonDrawerMethod: ExpenseSettleMethod;
}): ExpenseSettleMethod {
  if (!input.paidForm) return 'transfer';
  return resolveSettleMethodFromPaymentForm({
    paidForm: input.paidForm,
    alreadyPaidKind: input.alreadyPaidKind,
    nonDrawerMethod: input.nonDrawerMethod,
  });
}

export function buildPurchasePaymentOnReceive(input: {
  paidForm: ExpensePaidFormChoice | null;
  alreadyPaidKind: ExpenseAlreadyPaidKind | null;
  nonDrawerMethod: ExpenseSettleMethod;
  settleNote: string;
  paidDate: string;
  activeCashSessionId: string | null;
}): PurchasePaymentOnReceive {
  const method = resolvePurchaseReceptionSettleMethod({
    paidForm: input.paidForm,
    alreadyPaidKind: input.alreadyPaidKind,
    nonDrawerMethod: input.nonDrawerMethod,
  });
  if (method === 'cash_drawer' && !input.activeCashSessionId) {
    throw new PurchaseValidationError('Abrí un turno de caja para pagar en efectivo desde la caja.');
  }
  if (method === 'check') {
    throw new PurchaseValidationError('Pagá con cheque desde el detalle del pedido.');
  }
  const note = input.settleNote.trim() || null;
  if (method === 'other' && !note) {
    throw new PurchaseValidationError('Indicá cuándo y cómo se pagó.');
  }
  return {
    method,
    cashSessionId: method === 'cash_drawer' ? input.activeCashSessionId : null,
    note,
    paidAt: method === 'cash_drawer' ? undefined : isoDateToPaidAt(input.paidDate),
  };
}

export function assertPaymentOnReceiveForSettle(payment: PurchasePaymentOnReceive | undefined | null): asserts payment is PurchasePaymentOnReceive {
  if (!payment) {
    throw new PurchaseValidationError('Elegí cómo se pagó al recibir.');
  }
  if (payment.method === 'cash_drawer' && !payment.cashSessionId) {
    throw new PurchaseValidationError('Abrí un turno de caja para pagar en efectivo desde la caja.');
  }
}
